import { LocaleService } from '@sm360/widget-commons-core-services';

/**
 * Service is for utility functions for TradeInVehicle
 * @class TradeInVehicleService
 */
class TradeInVehicleService {
    getVehicleOptionsList(tradeInVehicle) {
        let optionsList = '';
        if (tradeInVehicle?.selectedVehicleOptions) {
            optionsList = tradeInVehicle.selectedVehicleOptions.reduce((acc, option) => {
                return `${acc}- ${option.description}\n`;
            }, '');
        }

        const options =
            tradeInVehicle?.selectedVehicleOptions && tradeInVehicle.selectedVehicleOptions.length > 0
                ? LocaleService.t('TRADE_IN.VEHICLE_OPTIONS.LIST', { optionsList })
                : LocaleService.t('TRADE_IN.SECTIONS_CONTENT.CONTACT_INFO.NO_OPTION');
        return options;
    }
}
export default new TradeInVehicleService();
